import { useEffect } from 'react';
import {
  generatePath,
  Outlet,
  useMatch,
  useNavigate,
  NavLink,
  useParams,
} from 'react-router-dom';
import { Tabs, IconLoader, PermissionDenied, PermissionEnum } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import { clearRateRequestListState } from './store/slices/list';

import ROUTES from '../../routes';

import cn from './rate-request.module.css';

const RateRequest = (): React.JSX.Element => {
  const {
    exchangeDictionaries: { currencies, activePermissions },
  } = useAppSelector((state) => state);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const match = useMatch(ROUTES.RATE_REQUEST);

  const { currency } = useParams();

  useEffect(() => {
    if (
      currencies &&
      currencies.length &&
      match &&
      activePermissions &&
      activePermissions.includes(
        PermissionEnum.SETTINGS_CUSTOM_RATE_EXCHANGE_LIST,
      )
    ) {
      navigate(generatePath(ROUTES.RATE_REQUEST_CURRENCY, { currency: 'all' }));
    }
  }, [currencies, activePermissions, match]);

  useEffect(
    () => () => {
      dispatch(clearRateRequestListState());
    },
    [],
  );

  useEffect(() => {
    let title = 'FX Rate request';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.rateRequestLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions && currencies && currencies.length) {
    if (
      activePermissions.includes(
        PermissionEnum.SETTINGS_CUSTOM_RATE_EXCHANGE_LIST,
      )
    ) {
      content = (
        <div className={cn.rateRequest}>
          <div className={cn.rateRequestTopWrapper}>
            <div className={cn.rateRequestTitle}>FX Rate request</div>
            {currencies && currencies?.length && (
              <div className={cn.rateRequestControlRow}>
                <Tabs
                  tabs={[
                    {
                      name: 'All',
                      path: generatePath(ROUTES.RATE_REQUEST_CURRENCY, {
                        currency: 'all',
                      }),
                    },
                    ...currencies.slice(0, 7).map((item) => {
                      const url = generatePath(ROUTES.RATE_REQUEST_CURRENCY, {
                        currency: item.id,
                      });

                      return {
                        name: item.name,
                        path: url,
                      };
                    }),
                  ]}
                  hiddenRoutes={currencies?.slice(7)?.map((item) => {
                    const url = generatePath(ROUTES.RATE_REQUEST_CURRENCY, {
                      currency: item.id,
                    });

                    return {
                      name: item.name,
                      path: url,
                    };
                  })}
                  wrapperClassName={cn.tabsWrapper}
                  itemClassName={cn.tabsItem}
                  enableRouting
                />
                <NavLink
                  to={generatePath(ROUTES.RATE_REQUEST_GENERAL, {
                    currency: currency || '',
                  })}
                  className={cn.generalSettings}
                >
                  General settings
                </NavLink>
              </div>
            )}
          </div>
          <Outlet />
        </div>
      );
    } else {
      content = <PermissionDenied />;
    }
  }

  return content;
};

export default RateRequest;
